import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollToTopElement"]

  connect() {
    console.log('scroll to top controller')
  }

  // This is attached to each button inside the pagination (Top & Bottom since they use the same files)
  scroll(event) {
    // pagination target is only on the bottom pagination
    const bottomPagination = event.target.closest('[data-scroll-to-top-target="scrollToTopElement"]')

    if (bottomPagination) {
      this.element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }
}
